import React from "react";
import { Button, Tooltip } from "antd";
import { ArrowLeftOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "../../styles/pageHeader.css";

// Single, consistent page heading for the whole app.
//   <PageHeader icon={<FileTextOutlined />} title="Document Library"
//      subtitle="Specs, SQL and control documents" tooltip="..." actions={<Button/>} />
// Optional back: pass onBack (fn), backTo (route), or backTo={-1} to go to the
// previous page (browser back).
function PageHeader({ icon, title, subtitle, tooltip, onBack, backTo, actions }) {
  const navigate = useNavigate();
  const isBack = backTo === -1 || backTo === "-1";
  const handleBack =
    onBack || (backTo != null ? () => navigate(isBack ? -1 : backTo) : null);

  return (
    <div className="arc-page-header">
      <div className="arc-page-header-left">
        {handleBack && (
          <Button
            className="arc-page-back"
            icon={<ArrowLeftOutlined />}
            onClick={handleBack}
          >
            Back
          </Button>
        )}
        {icon && <span className="arc-page-icon">{icon}</span>}
        <div className="arc-page-titles">
          <div className="arc-page-title">
            <span>{title}</span>
            {tooltip && (
              <Tooltip title={tooltip}>
                <InfoCircleOutlined className="arc-page-info" />
              </Tooltip>
            )}
          </div>
          {subtitle && <div className="arc-page-subtitle">{subtitle}</div>}
        </div>
      </div>
      {actions && <div className="arc-page-actions">{actions}</div>}
    </div>
  );
}

export default PageHeader;
